<template>
	<div class="page-mdl">
		<!-- 头部 -->
		<div class="course-head" v-if="detail">
			<div class="video-box">
				<div class="text" v-if="detail.imgType==1" :style="`background-color:${detail.courseColour};`">{{detail.courseName}}</div>
				<video v-if="detail.imgType==3" class="video" :src="detail.courseImg" controls=""></video>
				<img v-if="detail.imgType==2" class="video" :src="detail.courseImg" alt="">
			</div>
			<div class="info">
				<div class="title">
					{{detail.courseName}}
				</div>
				<div class="box">
					<div class="labels">
						<span class="act" v-if="detail.courseLevelName">{{detail.courseLevelName}}</span>
						<span v-if="detail.courseMajorLevelName">{{detail.courseMajorLevelName}}</span>
						<span v-if="detail.courseSubject">{{detail.courseSubject}}</span>
					</div>
					<span class="status" :class="detail.offerCoursesClass">{{detail.offerCoursesName}}</span>
				</div>
				
				<div class="more-info">
					<p><b>主讲教师：</b>{{detail.teacherName}} {{detail.teaTitle}} / {{detail.schoolSystem}}</p>
					<p><b>开课学期：</b>{{routeData.termName}}</p>
					<p><b>开课时间：</b>{{detail.courseStu.startTime}} 至 {{detail.courseStu.startTime}}</p>
					<p><b>课程学时：</b>{{detail.studyTime || 0}}学时</p>
				</div>
			</div>
		</div>
		
		
		<!-- 记录数据 -->
		<div class="course-data">
			<div class="title">运行期次：<span @click="courseIssueShow=true">{{nowQsTitle}}</span></div>
			<div class="list">
				<div class="item">
					<div class="value"><span>{{recordData.allChooseCount || 0}}</span>人次</div>
					<p>累计选课</p>
				</div>
				<div class="item">
					<div class="value"><span>{{recordData.chooseCount || 0}}</span>人次</div>
					<p>本次选课</p>
				</div>
				<div class="item">
					<div class="value"><span>{{recordData.allVisitCount || 0}}</span>次</div>
					<p>累计访问</p>
				</div>
				<div class="item">
					<div class="value"><span>{{recordData.visitCount || 0}}</span>次</div>
					<p>本次访问</p>
				</div>
			</div>
		</div>
		
		
		<!-- 内容 -->
		<div class="course-ctn" v-if="detail">
			<div class="m-tag-box2">
				<span :class="{act:index==courseTagIndex}" v-for="(item,index) in courseTag" :key="index"
					@click="changeCourseTag(index)">{{item}}</span>
			</div>
			
			<!-- 课程介绍 -->
			<div class="course-intro" v-if="courseTagIndex==0">
				<div class="intro" v-html="detail.introduction"></div>
				<div v-if="detail.courseOverview">
					<div class="tit">课程概述</div>
					<div class="course-html" v-html="detail.courseOverview"></div>
				</div>
				<div v-if="detail.courseBookList && detail.courseBookList.length>0">
					<div class="tit">参考资料</div>
					<ul class="book-list">
						<li v-for="(item,index) in detail.courseBookList" :key="index">
							{{item.bookName}} / {{item.bookHouse}} / {{item.bookDate}}
						</li>
					</ul>
				</div>
			</div>
			
			<!-- 章节 -->
			<div class="catelogue-mdl" v-if="courseTagIndex==1">
				<div class="cate-item" :class="{act:item.show}" v-for="(item,index) in chapterList" :key="index">
					<div class="head" @click="openChapter(index)">{{item.chapterName}}</div>
					<div class="list" v-show="item.show">
						<div class="item"
							v-for="(item2, index2) in item.actList" :key="item2.actId" @click="goStudyDetail(item2.actId)">
							<img class="ico" :src="require(`../../static/img/course/${item2.icon}`)"></img>
							<div class="tit line-clamp1">{{item2.actName}}</div>
							<!-- <text class="p" space="ensp">记{{item2.actPoint}}分  |  {{item2.statusName}}</text> -->
						</div>
					</div>
				</div>
			</div>

			
			<!-- 评论列表 -->
			<div v-if="courseTagIndex==2">
				<!-- <div class="comment-head">
					<div class="left">
						<div class="score">5.0分</div>
						<div class="des">
							<span>共0条评论</span>
							<van-rate v-model="commentScroe" :size="14" readonly  color="#ffd21e" void-icon="star" void-color="#eee" />
						</div>
					</div>
					<div class="right">
						<span>全部评价</span>
					</div>
				</div> -->
				<!-- <div class="comment-list" v-if="commentInfo.list.length>0">
					<div class="first-item" v-for="(item,index) in commentInfo.list" :key="index">
						<img class="head" :src="item.headImage || dfHead" mode=""></img>
						<div class="info">
							<div class="name">张晓丽</div>
							<div class="time">2022-05-11 发表 
								<van-rate v-model="commentScroe" :size="14" readonly  color="#ffd21e" void-icon="star" void-color="#eee" /></div>
							<div class="comment-ctn">这课程真的太好了</div>
						</div>
					</div>
				</div> -->
				<van-empty  description="暂无评论" />
			</div>
			
			<!-- 课程团队 -->
			<div class="teacher-mdl" v-if="courseTagIndex==3">
				<!-- 教师团队 -->
				<ul class="teacher-list big" >
					<li v-for="(item,index) in detail.teacherInfoVos" :key="item.teacherId">
						<img class="pic"  :src="item.headImage || dfHead2"alt="">
						<div class="info">
							<h3 class="name">{{item.teacherName}}<span>{{item.teacherTypeName}}</span></h3>
							<div class="label">{{item.orgName}}  {{item.title?' | '+item.title:''}}</div>
							<div class="des" v-if="item.introduction">{{item.introduction}}</div>
						</div>
					</li>
				</ul>
				
			</div>
			
		</div>
		
		<!-- 运行期次弹出层 -->
		<van-popup position="bottom" v-model="courseIssueShow" v-if="detail">
			<van-picker
				title="运行期次"
				show-toolbar
				value-key="qs"
				@confirm="changeTerm"
			    @cancel="courseIssueShow=false"
				:columns="detail.courseIssue"
			/>
		</van-popup>
	</div>
</template>
<script>
import { Rate } from 'vant';
export default {
	components:{
		vanRate:Rate
	},
	data () {
		return {
			courseId:'',	//课程id
			routeData:{},	//路由返回的信息(startTime, endTime, termName, termId, offerCourses)
			detail:null,	//详情
			
			courseTag:[
				'课程介绍','课程章节','课程评价','课程团队'
			],
			courseTagIndex:0,
			recordData:{},	//统计数据
			nowIndex:0,
			
			chapterList:[]	,//章节列表
			courseIssueShow:false,	//运行期次弹窗是否显示
			
			commentInfo:{
				list:[1,2,3],
				pageNum:1,
				pageSize:10,
				total:0,
				loading: true,
				finished: false,
			},
			commentScroe:5
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.courseId =  this.$route.params.id
		this.routeData = this.$route.query
		this.getDetail()
		this.getRecordData()
		this.recordVisitData()
		this.getChapterList()
	},
  
	computed:{
		nowQsTitle(){
			let name = ''
			const { detail } = this
			const { termId } = this.routeData
			if(detail){
				detail.courseIssue.forEach((item,index)=>{
					if(item.id==termId){
						name = item.qs
					}
				})
			}
			console.log('name',name,termId)
			return name
		}
	},
  
	methods:{
		//详情选项卡切换
		changeCourseTag(index){
			this.courseTagIndex = index
		},
		
		//根据课程ID查询详细数据
		getDetail(){
			const { courseId } = this
			const { termId } = this.routeData
			this.$axios({
				url:`/jxedu/api/site/findDetailById/${courseId}/${termId}`,
			}).then(res=>{
				let detail = res.data
				switch(detail.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
					case 1: detail.courseLevelName = '省级精品'; detail.courseLevelClass = 'blue'; break;
					case 2: detail.courseLevelName = '国家精品'; detail.courseLevelClass = 'blue'; break;
					case 3: detail.courseLevelName = '省级线上一流'; detail.courseLevelClass = 'orange'; break;
					case 4: detail.courseLevelName = '国家线上一流'; detail.courseLevelClass = 'green'; break;
				}
				
				switch(detail.courseStu.offerCourses){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
					case 1: detail.offerCoursesName = '即将开课'; detail.offerCoursesClass = 'orange'; break;
					case 2:detail.offerCoursesName = '开课中'; detail.offerCoursesClass = 'blue'; break;
					case 3:detail.offerCoursesName = '已结课'; detail.offerCoursesClass = 'gray'; break;
					case 4:detail.offerCoursesName = '暂未开课';detail.offerCoursesClass = 'gray'; break;
				}
				switch(detail.courseMajorLevel){	
					case 1: detail.courseMajorLevelName = '本科';  break;
					case 2:detail.courseMajorLevelName = '高职'; break;
				}
				
				detail.teacherInfoVos.forEach(item=>{
					switch(item.teacherType){	//老师分类：1责任老师 3主讲老师
						case 1: item.teacherTypeName = '责任老师'; break;
						case 3: item.teacherTypeName = '主讲老师'; break;
					}
				})
				console.log('detail',detail)
				this.detail = detail
			})
		},
		
		//根据课程期数查询累计、访问数据
		getRecordData(){
			const { courseId } = this
			const { termId } = this.routeData
			this.$axios({
				url:`/jxedu/api/site/findByTermId/${courseId}/${termId}`,
			}).then(res=>{
				this.recordData = res.data
			})
		},
		
		//获取课程章节
		getChapterList(){
			const { courseId } = this
			const { termId } = this.routeData
			this.$axios({
				url:`/jxedu/api/site/findChapterById/${courseId}`,
			}).then(res=>{
				let list = res.data
				list.forEach(item=>{
					item.show = true
					item.actList.forEach(item2=>{	//活动类型 1视频 2文本 3测验 4讨论
						switch(item2.actType){
							case 1: 
								item2.actTypeName = '【视频学习】';
								item2.icon = 'c-ico01.png';
								break;
							case 2:
								item2.actTypeName = '【文本学习】';
								item2.icon = 'c-ico01.png';
								break;
							case 3:
								item2.actTypeName = '【测验学习】';
								item2.icon = 'c-ico01.png';
								break;
							case 4:
								item2.actTypeName = '【讨论学习】';
								item2.icon = 'c-ico01.png';
								break;
						}
					})
				})
				console.log('list',list)
				this.chapterList = list
			})
		},
		
		//展开关闭章节
		openChapter(index){
			const { show } = this.chapterList[index]
			this.chapterList[index].show = !show
		},
		
		//记录站点访问数据
		recordVisitData(){
			const { courseId } = this
			const { termId } = this.routeData
			let ytSiteVisitInfo = {
				objectId:courseId,
				termId:termId,
				visitType:2
			}
			this.$axios({
				url:`/jxedu/site/visit/recordVisitData`,
				method:'POST',
				data:ytSiteVisitInfo,
			})
		},

		//切换运行期次
		changeTerm(item){
			this.routeData.termId = item.id
			this.getDetail()
			this.courseIssueShow = false
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/static/css/m-teacher.less';
@vm: 7.5vw;
.page-mdl{ background:#F6F6F6; }
.course-head{
	margin-bottom:20/@vm;
	.video-box{
		width:100%; height:420/@vm; background:#000;
		.video{ width:100%; height:100%; }
		.text{ 
			width:100%; height:100%; display:flex; justify-content: center; align-items: center; 
			font-size:96/@vm; color:#fff; line-height:136/@vm; font-weight: bold; letter-spacing: 10/@vm;
			padding:0 50/@vm; text-align: center; box-sizing: border-box;
		}
	}
	.info{
		padding:32/@vm; background:#fff;
		.title{
			font-size:36/@vm; line-height:52/@vm; color:#333333; font-weight:bold; margin-bottom:20/@vm;
		}
		.box{
			display:flex; justify-content: space-between; 
			.labels{
				flex:1; display:flex; flex-wrap:wrap; margin-bottom:28/@vm;
				span{ 
					display:inline-flex; align-items:center; height:48/@vm; padding:0 18/@vm; border-radius: 4/@vm; box-sizing: border-box;
					background:#fff; font-size:24/@vm; color:#1677FF; margin-right:12/@vm; border:2/@vm solid #1677FF;
					&.act{ background:#1677FF; color:#fff; }
				}
			}
			.status{
				display:inline-block; background:#EBF3FF; height:40/@vm; line-height:40/@vm; font-size:24/@vm; color:#1677FF;
				padding:0 10/@vm; border-radius:4/@vm; margin-top:4/@vm;
				&.orange{ background:#FFF1EA; color:#FF6010; }
				&.gray{ background:#EDEDED; color:#999999; }
			}
		}
		.more-info{
			background:#F7F8FA; padding:12/@vm 24/@vm;
			p{ line-height:48/@vm; color:#666666; font-size:24/@vm; }
		}
	}
}

.course-data{
	padding:40/@vm 32/@vm; background:#fff; margin-bottom:20/@vm;
	.title{
		color:#333333; font-weight:bold; font-size:30/@vm; line-height:36/@vm; margin-bottom:50/@vm;
		
	}
	.list{
		display:flex; justify-content: space-between;
		.item{
			flex:1; display:flex; align-items: center; justify-content: center; flex-wrap:wrap;
			.value{
				font-size:24/@vm; color:#333333; line-height:32/@vm; 
				span{ display:inline-block; font-size:32/@vm; color:#333333; font-weight: bold; line-height:32/@vm;}
				
			}
			p{ font-size:24/@vm; color:#666666; line-height:24/@vm; width:100%; text-align: center; margin-top:16/@vm;}

		}
	
	}
}

.course-ctn{
	background:#fff;
	.course-intro{
		padding:32/@vm;
		.intro{
			background: #F7F8FA;  background: #F7F8FA; border-radius: 6/@vm; border: 1px solid #F7F8FA;
			font-size:26/@vm; color:#333333; line-height:38/@vm;  padding:24/@vm 20/@vm;
		}
		.tit{ 
			font-size:36/@vm; line-height:36/@vm; height:36/@vm; color:#333333; margin-top:60/@vm; font-weight: bold; padding-left:48/@vm;
			background:url('../../static/img/course/ico-tit.png') no-repeat left center; background-size: 36/@vm 36/@vm;
		}
		.course-html{
			margin-top:28/@vm; font-size:26/@vm; color:#666; line-height:44/@vm;
			/deep/p{font-size:26/@vm; color:#666; line-height:44/@vm;}
		}
		.book-list{
			li{ font-size:26/@vm; color:#666; line-height:44/@vm; margin-bottom:20/@vm; }
		}
	}
	
	.catelogue-mdl{
		margin-top:32/@vm;
		.cate-item{
			.head{
				height:88/@vm;  background:#F8F9FD; padding:32/@vm;  position:relative; box-sizing: border-box;
				font-size:32/@vm; line-height:32/@vm; color:#313A4E; font-weight: bold;
				&::after{
					content:''; display:inline-block; width:26/@vm; height:26/@vm; @include bgImg('/learn/c-tri-down.png');
					position:absolute; right:32/@vm; top:50%; margin-top:-13/@vm; transition:all .3s;
				}
			}
			.list{
				height:0; overflow: hidden;
				.item{
					padding:32/@vm 32/@vm 32/@vm 84/@vm; position:relative;
					.ico{ display:inline-block; width:32/@vm; height:32/@vm; position:absolute; left:32/@vm; top:38/@vm; }
					.tit{ font-size:30/@vm; color:#313A4E; line-height: 44/@vm; }
					.p{ font-size:24/@vm; color:#8ABBFF; line-height:24/@vm; display: block; }
					&.unstart{
						.tit{ color:#313A4E; }
						.p{ color:#BCC3CD; }
					}
					&.finish{
						.tit, .p{ color:#BCC3CD; }
					}
				}
			}
			&.act{
				.head::after{ transform: rotate(180deg); }
				.list{ height:auto; }
			}
		}
	}
	
	.comment-head{
		display:flex; justify-content: space-between; margin:28/@vm 32/@vm; background:#F7F8FA; padding:20/@vm 24/@vm;
		border-radius:6/@vm;
		.left{
			.score{ font-size:52/@vm; line-height:52/@vm; color:#1677FF; }
			.des{
				margin-top:10/@vm; color:#666666; font-size:24/@vm; line-height:30/@vm; display:flex; align-items: center;
				span{ display:inline-block; margin-right:12/@vm; }
			}
		}
		.right{
			span{
				display:inline-block; margin-right:12/@vm; padding-right:26/@vm; font-size:24/@vm; color:#666666; position:relative;
				margin-top:62/@vm; line-height:30/@vm;
				&::after{
					content:''; width:20/@vm; height:20/@vm; position:absolute; right:0; top:50%; margin-top:-10/@vm;
					background:url('../../static/img/common/ico-down.png') no-repeat right center; background-size:20/@vm 20/@vm;
				}
			}
			
		}
	}
	// 评论列表
	.comment-list{
		padding:32/@vm 32/@vm 100/@vm;
		.first-item{
			display:flex; margin-bottom: 40/@vm;
			.head{ display:block; width:60/@vm; height:60/@vm; border-radius:60/@vm; margin-right:20/@vm; }
			.info{
				flex:1; padding-top:6/@vm; border-bottom:2/@vm solid #EEEEEE; padding-bottom:32/@vm;
				.name{ color:#74869E; font-size:26/@vm; line-height:26/@vm; margin-bottom:8/@vm; }
				.time{ color:#74869E; font-size:24/@vm; line-height:24/@vm; margin-bottom:14/@vm;}
				.comment-ctn{ 
					font-size:28/@vm; line-height:38/@vm; color:#313A4E;  display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden; -webkit-line-clamp: 6;
					.name2{ color:#74869E; margin-left:10/@vm; }
				 }
				.second-list{
					.second-item{
						display:flex; margin-top:40/@vm;
						.head{ width:48/@vm; height:48/@vm; }
						.info{ border-bottom:none; padding-bottom:0;}
					}
				}
			}
			.reply-more{ 
				font-size:24/@vm; color:#74869E; line-height:24/@vm; margin-top:24/@vm; position:relative; display:inline-block; padding-right:26/@vm;
				&::after{
					content:''; display:inline-block; width:20/@vm; height:20/@vm; @include bgImg('/common/tri-d.png'); 
					position:absolute; right:0; top:50%; margin-top:-10/@vm;
				}
			}
			&:last-child{ margin-bottom:0; 
				.info{ border-bottom:0; }
			}
		}
	}
}

.teacher-mdl{
	padding:28/@vm 32/@vm;
}

</style>



// WEBPACK FOOTER //
// src/pages/course-detail/tpl-mobile.vue